import { createCustomEvent } from "../../../../javascript/shared/helpers";
import { makeSchedulable, SchedulablesController } from "./schedulable_helpers"

export default makeSchedulable(class extends SchedulablesController {
  static targets = ["repeatUpdatePrompt"]

  confirmDelete(event) {
    event && event.preventDefault && event.preventDefault()
    if (confirm("Are you sure?")) {
      this.submitDeleteRequest({ detail: { actionType: "delete" } });
    }
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "schedulables:submit-repeat-action", this.submitDeleteRequest)
  }

  executeConnectLogic() {
    this.submitDeleteRequest = this.submitDeleteRequest.bind(this);
    App.Helpers.listenToCustomEvent(document, "schedulables:submit-repeat-action", this.submitDeleteRequest);
    this.emitDeleteSuccessEvent = this.emitDeleteSuccessEvent.bind(this)
  }

  submitDeleteRequest(event) {
    const { actionType, all } = (event.detail || {});
    actionType == "delete" && App.Helpers.ajaxRequest({ url: this.urlFor(all), method: "delete", successHandler: this.emitDeleteSuccessEvent })
  }

  urlFor(all) {
    return this.url.replace(/ALL_PLACEHOLDER/g, all || "")
  }

  emitDeleteSuccessEvent(response) {
    const { date, all, is_repeat: isRepeat } = response
    document.dispatchEvent(createCustomEvent("list-item:delete-success", this.element, { ...response, listItemID: this.schedulableID, schedulableType: this.schedulableType }));
    document.dispatchEvent(createCustomEvent("schedulables:delete-success", this.element, { schedulableID: this.schedulableID, schedulableType: this.schedulableType, date, all, isRepeat }))
  }

  redirectTo({ new_url }) {
    if (new_url) document.location = new_url
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get("url")
  }
});



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-delete-link-controller.js